import { ReactElement } from 'react';
import ExerciseCategoryManagement from '../../../components/exerciseCategory/ExerciseCategoryManagement';

const SuperAdminExerciseCategories = (): ReactElement => {
  return (
    <ExerciseCategoryManagement mode="superAdmin" />
  )
}

export default SuperAdminExerciseCategories